// Page view tracking is delayed to ignore redirects & make sure all props are up-to-date like document.title
export const pageViewTrackingDelay = 1000;